import PolicyAndTermsCardView from './detail-card-container';

export type { ProfileDetails } from './detail-card-view';

export default PolicyAndTermsCardView;
